import {DatePipe} from '@angular/common';
import {Component, computed, inject} from '@angular/core';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {IonFooter, IonNavLink, IonRow} from '@ionic/angular/standalone';
import {TranslocoDirective} from '@jsverse/transloco';
import {environment} from '../../../environments/environment';
import {TranslateHelperService} from '@services';

@Component({
	           selector: 'app-footer',
	           standalone: true,
	           imports: [
			TranslocoDirective,
		           DatePipe,
		           IonFooter,
		           IonNavLink,
		           IonRow,
		           RouterLinkActive,
		           RouterLink
	           ],
	           templateUrl: './footer.component.html',
	           styleUrls: ['./footer.component.scss']
           })
export class FooterComponent {
	public today = Date.now();
	public actualVersion = computed(() => environment.actualVersion);
	public translateService: TranslateHelperService = inject(TranslateHelperService);
}
